import i18n from '../../../Utils/i18n';
import { ReportFormat, ReportType } from '../../../Utils/Constants';

export function getReportTypeInfo(reportType) {
  if (reportType === null) {
    return {};
  }
  switch (reportType) {
    case ReportType.WEBINAR_ATTENDEE_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.attendee.title'),
        description: i18n.t('generateReport.reportTypeCards.attendee.description'),
        iconClass: 'reportIcon attendee-icon',
        isNewReport: false,
        isVeryNewReport: false
      };

    case ReportType.WEBINAR_REGISTRATION_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.registration.title'),
        description: i18n.t('generateReport.reportTypeCards.registration.description'),
        iconClass: 'reportIcon registration-icon',
        isNewReport: false,
        isVeryNewReport: false
      };

    case ReportType.WEBINAR_RECORDING_REPORT:
      return {
        title: i18n.t('generateReport.reportTypeCards.recording.title'),
        description: i18n.t('generateReport.reportTypeCards.recording.description'),
        iconClass: 'reportIcon recording-icon',
        isNewReport: false,
        isVeryNewReport: false
      };

    default:
      console.warn('Invalid Report Type selected');
      return {};
  }
}

export function getReportFormatInfo(reportFormat) {
  if (reportFormat === null) {
    return {};
  }
  switch (reportFormat) {
    case ReportFormat.PDF:
      return {
        title: i18n.t('report.format.pdf')
      };

    case ReportFormat.XLSX:
      return {
        title: i18n.t('report.format.excel')
      };

    case ReportFormat.CSV:
      return {
        title: i18n.t('report.format.csv')
      };

    default:
      console.warn('Invalid Report Format selected');
      return {};
  }
}

export class WizardStepID {
  static get SELECT_REPORT_TYPE() {
    return 'SELECT_REPORT_TYPE';
  }

  static get FILTER_RECORDS() {
    return 'FILTER_RECORDS';
  }

  static get SELECT_REPORT_FORMAT() {
    return 'SELECT_REPORT_FORMAT';
  }
}

export function validateSelection(reportType, combinedStats = {}) {
  let result = {
    error: null,
    moreInfoTooltip: null,
    subMessage: null
  };
  if (reportType === null) {
    return result;
  }
  const { numberOfSelectedSessions, numberOfSelectedWebinars, numberOfSelectedRecordings } = combinedStats;

  switch (reportType) {
    case ReportType.WEBINAR_ATTENDEE_REPORT:
      if (numberOfSelectedSessions === 0) {
        result.error = i18n.t('generateReport.warning.noWebinar');
      } else if (numberOfSelectedSessions > 1) {
        result.error = `${i18n.t('generateReport.warning.oneWebinar')} ${i18n.t('generateReport.info.newReportAlert', {
          newReportAlert: i18n.t('generateReport.reportType.attendeeV2')
        })}`;
      }
      break;
    case ReportType.WEBINAR_REGISTRATION_REPORT:
      if (numberOfSelectedWebinars === 0) {
        result.error = i18n.t('generateReport.warning.noWebinar');
      } else if (numberOfSelectedWebinars > 1) {
        result.error = i18n.t('generateReport.warning.oneWebinar');
        result.moreInfoTooltip = i18n.t('generateReport.info.futureWebinarsMessage');
      }
      break;
    case ReportType.WEBINAR_RECORDING_REPORT:
      if (numberOfSelectedRecordings === 0) {
        result.error = i18n.t('generateReport.warning.noRecording');
      } else if (numberOfSelectedRecordings > 1) {
        result.error = i18n.t('generateReport.warning.oneRecording');
        result.moreInfoTooltip = i18n.t('generateReport.info.futureRecordingsMessage');
      }
      break;
    default:
      console.warn('Invalid reportType selected');
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/GoToWebinar/GenerateReport/AdminWizard/GenerateAdminReportWizardUtils.js